// extracted by mini-css-extract-plugin
export var header = "pages-auth-__ResetPassword-module___header";
export var passwordValidationBox = "pages-auth-__ResetPassword-module___passwordValidationBox";
export var resendBtn = "pages-auth-__ResetPassword-module___resendBtn";
export var resetPasswordHeader = "pages-auth-__ResetPassword-module___resetPasswordHeader";
export var returnLink = "pages-auth-__ResetPassword-module___returnLink";
export var subText = "pages-auth-__ResetPassword-module___subText";